import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';
import translationTN from './locales/tn/translation.json';
import translationAR from './locales/ar/translation.json';
import translationDE from './locales/de/translation.json';

//the translations
const resources = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
  ar: {
    translation: translationAR,
  },
  tn: {
    translation: translationTN,
  },
  de: {
    translation: translationDE,
  },
};

const lnDetectorOptions = {
  // order and from where user language should be detected
  order: ['cookie', 'htmlTag', 'localStorage', 'path', 'subdomain'],

  // cache user language on
  caches: ['cookie'],
};

const backendOptions = {
  // path where resources get loaded from, or a function
  loadPath: './locales/{{lng}}/translation.json',
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    supportedLngs: ['en', 'fr', 'ar', 'tn', 'de'],
    resources,
    debug: false,
    fallbackLng: 'en',
    detection: lnDetectorOptions,
    backend: backendOptions,
    react: { useSuspense: false },
  });

export default i18n;
